import 'assets/css/dev.css'

function Element({
  id = 'id',
  list = [],
  value = '',
  valueKey = 'value',
  textKey = 'text',
  valueDisplay = false,
  className = 'input-select block arrow',
  register = null,
  root = '',
  rootValue = '',
  disabled = false,
  styles = {},
  onChange = () => {},
}) {
  return (
    <select
      id={id + ''}
      value={register ? undefined : value}
      className={className}
      disabled={disabled}
      onChange={onChange}
      style={styles}
      {...register}
    >
      {root !== '' && <option value={rootValue}>{root}</option>}
      {list.map((data, index) => (
        <option value={data[valueKey]} key={`option_${index}`}>
          {valueDisplay && `[${data[valueKey]}]`}
          {data[textKey]}
        </option>
      ))}
    </select>
  )
}

export default Element
